import { type SdkUser } from '@dynamic-labs/sdk-api-core';

import type { DynamicClient } from '../../../../../client/types/DynamicClient';
import { MissingUserVerificationError } from '../../../../../errors/MissingUserVerificationError';
import { assertDefined } from '../../../../../utils/assertDefined';
import { getMissingVerificationForCoinbaseOnrampOrder } from '../../getMissingVerificationForCoinbaseOnrampOrder';

export const validateUserCredentialsForCoinbaseOnrampOrder = (
  client: DynamicClient
): SdkUser => {
  const { user } = client;

  assertDefined(user, 'User is not authenticated');

  const fieldsMissingVerification =
    getMissingVerificationForCoinbaseOnrampOrder(
      { paymentMethod: 'GUEST_CHECKOUT_APPLE_PAY' },
      client
    );

  const missingEmailVerification = fieldsMissingVerification.find(
    (field) => field.field === 'email'
  );

  if (missingEmailVerification) {
    throw new MissingUserVerificationError({
      informationToVerify: 'email',
      message:
        'User must have a verified email to create a Coinbase onramp order',
    });
  }

  const missingPhoneNumberVerification = fieldsMissingVerification.find(
    (field) => field.field === 'phoneNumber'
  );

  if (
    missingPhoneNumberVerification &&
    missingPhoneNumberVerification.errorCode !== 'VERIFICATION_EXPIRED'
  ) {
    throw new MissingUserVerificationError({
      informationToVerify: 'phoneNumber',
      message:
        'User must have a verified phone number to create a Coinbase onramp order',
    });
  }

  // this is a requirement for Coinbase Onramp
  // https://docs.cdp.coinbase.com/api-reference/v2/rest-api/onramp/create-an-onramp-order#body-phone-number-verified-at
  if (
    missingPhoneNumberVerification &&
    missingPhoneNumberVerification.errorCode === 'VERIFICATION_EXPIRED'
  ) {
    throw new MissingUserVerificationError({
      informationToVerify: 'phoneNumber',
      message:
        "The user's phone number has not been verified in the last 60 days. Please re-verify the user's phone number",
    });
  }

  return user;
};
